import { useQuery } from "@tanstack/react-query"

import { apiFetch } from "@/api/client"

export interface PostbackLogRow {
  id: number
  received_at: string | null
  fired_at: string | null
  offer_id: number
  offer_name: string | null
  campaign_id: number | null
  campaign_name: string | null
  click_id: string | null
  transaction_id: string
  ttclid: string | null
  payout: number | null
  status: string
  http_status: number | null
  tiktok_response_code: number | null
  tiktok_response_body: string | null
  tiktok_event_id: string | null
  attempts: number
}

export interface PostbackLogResponse {
  total: number
  limit: number
  offset: number
  rows: PostbackLogRow[]
}

export interface PostbackStats {
  window: "24h" | "7d" | "30d" | "custom"
  total: number
  fired: number
  failed: number
  skipped: number
  pending: number
  success_rate: number | null
  last_received_at: string | null
}

export interface PostbackStatsFilters {
  window?: "24h" | "7d" | "30d"
  date_from?: string
  date_to?: string
}

export interface PostbackLogFilters {
  offer_id?: number
  campaign_id?: number
  status?: string
  forwarded?: "fired" | "failed" | "pending" | "skipped"
  q?: string
  date_from?: string
  date_to?: string
  limit?: number
  offset?: number
}

function buildQuery(f: PostbackLogFilters): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(f)) {
    if (v === undefined || v === null || v === "") continue
    qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ""
}

export function usePostbackLog(filters: PostbackLogFilters) {
  return useQuery<PostbackLogResponse>({
    queryKey: ["postback", "log", filters],
    queryFn: () =>
      apiFetch<PostbackLogResponse>(`/api/postback/log${buildQuery(filters)}`),
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
    retry: false,
  })
}

export function usePostbackStats(filters: PostbackStatsFilters) {
  return useQuery<PostbackStats>({
    queryKey: ["postback", "log", "stats", filters],
    queryFn: () =>
      apiFetch<PostbackStats>(`/api/postback/log/stats${buildQuery(filters)}`),
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
    retry: false,
  })
}
